/**
 * The width of the bounding box stroke.
 *
 * @constant {number}
 */
export const BoundingBoxStrokeWidth = 2;

/**
 * The width of the bounding box shadow stroke.
 *
 * @constant {number}
 */
// eslint-disable-next-line sort-exports/sort-exports
export const BoundingBoxShadowStrokeWidth = BoundingBoxStrokeWidth * 2;

/**
 * The duration to show the cursor as selected after the mouse has been released.
 *
 * @constant {number}
 */
export const CursorSelectedDuration = 500;

/**
 * The width of the cursor stroke.
 *
 * @constant {number}
 */
export const CursorStrokeWidth = 1;

/**
 * The width of the cursor shadow stroke.
 *
 * @constant {number}
 */
// eslint-disable-next-line sort-exports/sort-exports
export const CursorShadowStrokeWidth = CursorStrokeWidth * 2;

/**
 * The cursor width and height.
 *
 * @constant {number}
 */
export const CursorSize = 16;

/**
 * The keys that can be used to confirm fast frame.
 *
 * @constant {number | string[]}
 */
export const EnterKeys = [13, 'Enter'];

/**
 * The keys that can be used to escape fast frame.
 *
 * @constant {number | string[]}
 */
export const EscapeKeys = [27, 'Escape'];

/**
 * The width of the notch.
 *
 * @constant {number}
 */
export const NotchWidth = CursorSize;

/**
 * The scale of the bounding box.
 *
 * @constant {number}
 */
export const Scale = 0.1;

/**
 * The opacity of the shadow.
 *
 * @constant {number}
 */
export const ShadowOpacity = 0.65;
